import { tokens, applyFont } from '@domain-group/fe-brary';
var designTokenFont = token => applyFont(tokens.typography[token]);
export var designTokenFonts = Object.fromEntries(Object.keys(tokens.typography).map(font => [font, designTokenFont(font)]));
export default designTokenFont;